// extracted by mini-css-extract-plugin
export var formContainer = "_ia-0";
export var message = "_ia-1";